var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "580" },
      model: {
        value: _vm.disconnectedSettingDialog,
        callback: function ($$v) {
          _vm.disconnectedSettingDialog = $$v
        },
        expression: "disconnectedSettingDialog",
      },
    },
    [
      _c("custom-dialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("span", [_vm._v(_vm._s(_vm.tdl("abnormalStatusSetting")))]),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.disconnectedSettingDialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-6",
                        attrs: { id: "dialog_content", cols: "12" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pb-4 section_border",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 text-left",
                                attrs: { cols: "6" },
                              },
                              [
                                _c("span", { staticClass: "label_font" }, [
                                  _vm._v(
                                    _vm._s(_vm.tdl("notificationTimeSetting"))
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "6" },
                              },
                              [
                                _c("v-select", {
                                  staticClass: "ma-0 pa-0 custom_select",
                                  attrs: {
                                    items: _vm.timeList,
                                    dense: "",
                                    "hide-details": "",
                                    outlined: "",
                                    dark: "",
                                    "item-text": "label",
                                    "item-value": "value",
                                  },
                                  model: {
                                    value: _vm.selectedTime,
                                    callback: function ($$v) {
                                      _vm.selectedTime = $$v
                                    },
                                    expression: "selectedTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pt-4 pb-4 section_border d-none",
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pb-2 text-left",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("span", { staticClass: "label_font" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tdl("notificationDestinationSetting")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "auto" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.enableEmailNotification,
                                              expression:
                                                "enableEmailNotification",
                                            },
                                          ],
                                          attrs: {
                                            id: "check_box",
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.enableEmailNotification
                                            )
                                              ? _vm._i(
                                                  _vm.enableEmailNotification,
                                                  null
                                                ) > -1
                                              : _vm.enableEmailNotification,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.enableEmailNotification,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.enableEmailNotification =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.enableEmailNotification =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.enableEmailNotification =
                                                  $$c
                                              }
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2 ml-3",
                                        attrs: { cols: "8" },
                                      },
                                      [
                                        _c("v-text-field", {
                                          staticClass:
                                            "ma-0 pa-0 custom_textfield",
                                          attrs: {
                                            dense: "",
                                            "hide-details": "",
                                            outlined: "",
                                            dark: "",
                                            placeholder: "Email address",
                                          },
                                          model: {
                                            value: _vm.emailAddress,
                                            callback: function ($$v) {
                                              _vm.emailAddress = $$v
                                            },
                                            expression: "emailAddress",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 ml-auto",
                                        attrs: { cols: "3" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-0 pa-0 blue_btn",
                                            attrs: {
                                              width: "100%",
                                              height: "2.5rem",
                                              loading: _vm.testEmailLoading,
                                            },
                                            on: { click: _vm.sendTestEmail },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.tdl("testEmailSend")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "ma-0 pt-4 pb-4" },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pb-2 text-left",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("span", { staticClass: "label_font" }, [
                                  _vm._v(
                                    _vm._s(_vm.tdl("notificationAlarmSetting"))
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 admin_list_container",
                                attrs: { cols: "12" },
                              },
                              [
                                _vm._l(
                                  _vm.administratorList,
                                  function (admin, index) {
                                    return _c(
                                      "v-row",
                                      {
                                        key: index,
                                        staticClass: "ma-0 admin_list_item",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: admin.checked,
                                                  expression: "admin.checked",
                                                },
                                              ],
                                              attrs: {
                                                id: "check_box",
                                                type: "checkbox",
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  admin.checked
                                                )
                                                  ? _vm._i(
                                                      admin.checked,
                                                      null
                                                    ) > -1
                                                  : admin.checked,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = admin.checked,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          admin,
                                                          "checked",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          admin,
                                                          "checked",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      admin,
                                                      "checked",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pl-4",
                                            attrs: { cols: "5" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "admin_name" },
                                              [_vm._v(_vm._s(admin.name))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 text-right",
                                            attrs: { cols: "5" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "admin_email" },
                                              [
                                                _vm._v(
                                                  _vm._s(admin.mailAddress)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm.administratorList.length === 0
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-10",
                                        attrs: { cols: "12", align: "center" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#8E8E8E" } },
                                          [_vm._v(_vm._s(_vm.t("noData")))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-6",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 grey_btn",
                                attrs: { width: "10rem", height: "2.5rem" },
                                on: {
                                  click: function ($event) {
                                    _vm.disconnectedSettingDialog = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("cancel")))]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-4 blue_btn",
                                attrs: { width: "10rem", height: "2.5rem" },
                                on: { click: _vm.saveSetting },
                              },
                              [_vm._v(" " + _vm._s(_vm.tdl("confirm")) + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }